import { createAction } from "redux-actions";

export const CART_FUNNEL_LIST = "CART_FUNNEL_LIST";
export const cartFunnelList = createAction(CART_FUNNEL_LIST);

export const CART_FUNNEL_DETAILS = "CART_FUNNEL_DETAILS";
export const cartFunnelDetails = createAction(CART_FUNNEL_DETAILS);

export const ADD_CART_FUNNEL = "ADD_CART_FUNNEL";
export const addCartFunnel = createAction(ADD_CART_FUNNEL);

export const UPDATE_CART_FUNNEL = "UPDATE_CART_FUNNEL";
export const updateCartFunnel = createAction(UPDATE_CART_FUNNEL);

export const DELETE_CART_FUNNEL = "DELETE_CART_FUNNEL";
export const deleteCartFunnel = createAction(DELETE_CART_FUNNEL);

export const EMAIL_SENDING = "EMAIL_SENDING";
export const emailSending = createAction(EMAIL_SENDING);
